import axiosInstance from "./axiosInstance";

const getAllCoinsHistory = async ({ pageParam = 1 }) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const { data } = await axiosInstance.get(
      `/api/coins-history?page=${pageParam}&limit=10`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return {
      coinsHistory: data.coinsHistory,
      nextPage: pageParam + 1,
      totalPages: data.pagination.totalPages,
    };
  } catch (error) {
    throw new Error("Error fetching coins history.");
  }
};

export default getAllCoinsHistory;
